import * as classNames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import Spinner, { SpinnerColorType } from '../Spinner/Spinner'

import * as styles from './ActionButton.css'

interface ActionButtonProps {
  handleClick?: () => void
  isEnabled?: boolean
  isLoading?: boolean
  children: string
}

const ActionButton: React.FunctionComponent<ActionButtonProps> = ({
  handleClick,
  isEnabled = true,
  children,
  isLoading = false
}) => {
  let content = <div className={styles.text}>{children}</div>

  let dom = <div className={classNames(styles.disabledButton, styles.button)}>{content}</div>

  if (isLoading) {
    content = (
      <div className={styles.spinner}>
        <Spinner color={SpinnerColorType.WHITE} />
      </div>
    )
    dom = <div className={classNames(styles.enabledButton, styles.button)}>{content}</div>
  }

  if (isEnabled && !isLoading) {
    dom = (
      <div className={classNames(styles.enabledButton, styles.button)} onClick={handleClick}>
        {content}
      </div>
    )
  }
  return dom
}

export default compose<ActionButtonProps, ActionButtonProps>(pure)(ActionButton)
